import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
import { service } from "@modules/newCommunity/setup";
let deduplicationClassDialog = class deduplicationClassDialog extends Vue {
  constructor() {
    super(...arguments);
    this.settingClassId = "";
    this.settingList = [];
    this.selectLoading = false;
    this.selectObj = {
      pageSize: 20,
      pageNum: 1
    };
    this.totalPage = 0;
  }
  handleAttrValueFilter(val) {
    if (!this.selectLoading) {
      this.selectObj.settingName = val;
      this.selectObj.pageNum = 1;
      this.findSettingList();
    }
    this.$nextTick(() => {
      this.$refs.settingSelect.$el.children[1].children[0].children[0].scrollTop = 0;
    });
  }
  handleLoadmore() {
    if (!this.selectLoading && this.selectObj.pageNum < this.totalPage) {
      this.selectObj.pageNum++;
      this.findSettingList();
    }
  }
  handleFouces() {
    this.handleAttrValueFilter("");
  }
  settingListWatcher(newVal) {
    if (newVal.some(item => item.id == this.participateRepeatedClassId)) {
      this.settingClassId = Number(this.participateRepeatedClassId);
    }
  }
  findSettingList() {
    this.selectLoading = true;
    service.findActivityCommonSettingPage({
      ...this.selectObj,
      settingBusinessType: "MEDICAL_QUESTIONNAIRE_REPEATED_CLASS_ID",
      activitySource: "MEDICAL_QUESTIONNAIRE_ACTIVITY"
    }).then(res => {
      if (res.code === 200) {
        if (this.selectObj.pageNum !== 1) {
          this.settingList.push(...res.data.rows);
        } else {
          this.settingList = res.data.rows;
        }
        this.totalPage = res.data.totalPage;
        this.selectLoading = false;
      }
    }).finally(() => {
      this.selectLoading = false;
    });
  }
  onConfirm() {
    const settingItem = this.settingList.filter(item => item.id == this.settingClassId)[0];
    this.$emit("settingClassChange", settingItem);
    this.visible = false;
  }
  onOpen() {
    this.settingClassId = this.participateRepeatedClassId ? this.participateRepeatedClassName + `（id：${this.participateRepeatedClassId}）` : "";
    if (this.settingList.some(item => item.id == this.participateRepeatedClassId)) {
      this.settingClassId = Number(this.participateRepeatedClassId);
    }
    this.findSettingList();
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], deduplicationClassDialog.prototype, "visible", void 0);
__decorate([Prop({
  default: ""
})], deduplicationClassDialog.prototype, "participateRepeatedClassId", void 0);
__decorate([Prop({
  default: ""
})], deduplicationClassDialog.prototype, "mode", void 0);
__decorate([Prop({
  default: ""
})], deduplicationClassDialog.prototype, "participateRepeatedClassName", void 0);
__decorate([Watch("settingList", {
  deep: true
})], deduplicationClassDialog.prototype, "settingListWatcher", null);
deduplicationClassDialog = __decorate([Component({
  name: "deduplicationClassDialog",
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const condition = SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop - 15 <= SELECTWRAP_DOM.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  }
})], deduplicationClassDialog);
export default deduplicationClassDialog;